<template>
  <div>
    <div>
    <mdb-row class=" justify-content-center">
      <mdb-col xl="9" class="pb-2">
         <img src="@/assets/admin.svg" alt="sms" height="500px" class="img-fluid">
      </mdb-col>
    </mdb-row>
  </div>
  </div>
</template>

<script>
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCol from 'mdbvue/lib/components/mdbCol'

export default {
  components: {
    mdbRow,
    mdbCol
  }
}
</script>
